import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "navigation-progress",
  role: "progressbar",
  "aria-label": "正在切换页面"
};
const _hoisted_2 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AppHeader = _resolveComponent("AppHeader");
  const _component_router_view = _resolveComponent("router-view");
  const _component_AppFooter = _resolveComponent("AppFooter");
  const _component_AnnouncementPopup = _resolveComponent("AnnouncementPopup");
  const _component_ApiFaultNotice = _resolveComponent("ApiFaultNotice");
  return _openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({
      'is-home': $setup.isHome
    })
  }, [_createVNode(_component_AppHeader), $setup.navigating ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component,
      route
    }) => [_createElementVNode("div", {
      class: _normalizeClass(["route-stage", {
        'route-enter': $setup.arriving
      }]),
      onAnimationend: _cache[0] || (_cache[0] = _withModifiers($event => $setup.arriving = false, ["self"]))
    }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
      key: route.path
    }))], 34)]),
    _: 1
  })]), _createVNode(_component_AppFooter), _createVNode(_component_AnnouncementPopup), _createVNode(_component_ApiFaultNotice)], 2);
}